export const tabContent = {
  TAB_1: {
    imgUrl: '/images/aiPillarPage/professionals.jpg',
    description: `Sometimes all you want to do is to perform the functions of your job and go home. But there is much more to being a professional in the workforce, which can include various emails, instant messages, and reports.
    <br />
    <br />
    Writing isn't necessarily in everyone's job description, but most everyone has to write down something at work. And if that's not your cup of tea (or even if it is, and you're just not feeling it for whatever reason), AI is here to help.
    <br />
    <br />
    AI writers can whip up emails and professional messages like nobody's business. If you're too busy for the polite niceties that come with working a professional job, share some tasks with your AI writer of choice.
    `,
  },
  TAB_2: {
    imgUrl: '/images/aiPillarPage/students.jpg',
    description: `<a target="_blank"  rel="noreferrer" href="https://quillbot.com/blog/essay-writing-hacks-using-quillbot/">Essays</a>, book reports, and write ups - oh my!
    <br /><br />
      We know that homework can, and does, pile up. Every teacher thinks their class is your only class, right?
      <br /><br />
    <span style='background-color:#FFDD2E'>When your workload becomes overwhelming, AI writers can relieve you of a lot of your stress.</span> Although you'll need to have an opinion on the book you're writing a report on, once you input all of your data into the AI writer, it can take it from there.
      <br /><br />
      School is stressful enough, and your free time shouldn't be affected the same way.
      `,
  },
  TAB_3: {
    imgUrl: '/images/aiPillarPage/bloggers.jpg',
    description: `Is your blog stale? Are you having a hard time coming up with topics to write about? Maybe you can come up with the topics, but it's the content creation that's giving you pause.
    <br /><br />
      You already know the solution to these problems.
      <span style='background-color:#FFDD2E'>AI writers are great for revitalizing blogs because once they understand your tone and writing voice, they can run with it to create content that's totally you.</span>
      <br /><br />
      It's a lot of work to maintain a blog, generate unique content, keep up with SEO practices and make Google happy, and ensure your readers are remaining engaged with every blog post.
      <br /><br />
      It's time to share some of that work. It's time to make your life easier.
      `,
  },
  TAB_4: {
    imgUrl: '/images/aiPillarPage/copywriters.jpg',
    description: `Ad and website copy needs to be snappy and eye-catching. The words need to be chosen carefully, with each filling a specific purpose towards your message.
    <br /><br />
      By filling in the parameters of what you need and would like to see in your copy, the AI is able to produce the perfect language to represent your product, service, or company. <span style='background-color:#FFDD2E'>Instead of spending hours agonizing over being clever, just have the robot do it for you.</span>
      <br /><br />
      It's really that easy.
      `,
  },
  TAB_5: {
    imgUrl: '/images/aiPillarPage/everyone.jpg',
    description: `No matter who you are or what you do, you'll have to write something at some point in your life.
<br /><br />
    Sometimes you don't want to. Sometimes English (or any language you need to write in) is not your native language. Sometimes you're so busy that the thought of writing anything is overwhelming.
    <br /><br />
    AI, friends, is the answer to everything. There is no reason not to use an AI writer. If you don't like the final product, then you can edit it. But the bulk of the work will be done, in that case, and your job will be significantly lighter than if you had taken on everything alone.
    <br /><br />
    Just try it out. If you don't like it, you don't have to use it.
    But you'll be hooked. Guaranteed.
      `,
  },
};

export const benefitsData = [
  {
    title: 'It will save time.',
    text: 'Because you’re not generating all the content on your own, agonizing over the right words to use, articles, essays, <a rel="noreferrer" target="_blank" href="https://www.quillbot.com/blog">blog posts</a>, and all other writing will get done in a breeze. Machines are fast, and the AI writer is no exception to that rule.',
    background: '#EDFFF0',
  },
  {
    title: 'It will create fresh content.',
    text: 'Because the AI article writer is able to generate content on its own, everything that it creates will be new and unique, based on the parameters you provide it.',
    background: '#CAFCD4',
  },
  {
    title: 'Quality will be high.',
    text: 'The AI writer has the ability to choose the right words, check for <a href="/grammar-check">grammar mistakes</a>, understand more languages than just English, and optimize for SEO.',
    background: '#8FE39E',
  },
  {
    title: 'It’s free.',
    text: 'As we’ve discussed, although some AI writers will cost you, there are plenty that can be used on a free plan, saving you time and money. And there is nothing better than something that’s free.',
    background: '#61C774',
  },
];
